import { render } from "./AppFormPopup.vue?vue&type=template&id=3ad00e70&lang=pug"
import script from "./AppFormPopup.vue?vue&type=script&lang=js"
export * from "./AppFormPopup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\projects\\phpstorm\\amerika\\newjobs4you\\public_html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__